export function getOfficeList(data) {
    let { getOfficeListRequest, getOfficeListError, getOfficeListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_office_list',
        this.createBundle('get_office_list', { search: data }, this.GET, getOfficeListRequest, getOfficeListResult, getOfficeListError)
    )
}
